import makeStyles from '@mui/styles/makeStyles';
import { checkboxLabel, stepContainer } from '../ui/styles';

// Figma confirm screen (72:1281): 24px between the summary rows, the actions
// box and the checkbox. Summary rows are plain text on white (no box) -
// label + 8px + value, 8px between rows. Action items are captions (12/15)
// numbered flush with the box padding, 8px apart.
export const createClasses = makeStyles(theme => ({
  container: {
    ...stepContainer(theme),
    gap: theme.spacing(3)
  },
  summaryBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  summaryRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'baseline'
  },
  summaryLabel: {
    fontWeight: 500,
    lineHeight: '19px'
  },
  summaryValue: {
    color: theme.palette.text.secondary,
    lineHeight: '19px',
    wordBreak: 'break-all'
  },
  actionsList: {
    margin: 0,
    padding: 0,
    listStylePosition: 'inside',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    '& > li': {
      fontSize: '12px',
      lineHeight: '15px'
    }
  },
  confirmationLabel: checkboxLabel(theme)
}));
